import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, Send, CheckCircle, AlertCircle, Clock, GraduationCap } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Dashboard = () => {
  const [stats, setStats] = useState({
    total_contacts: 0,
    total_students: 0,
    total_campaigns: 0,
    messages_sent: 0,
    messages_pending: 0,
    messages_failed: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/dashboard/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
    setLoading(false);
  };

  const statCards = [
    {
      title: 'Total de Contatos',
      value: stats.total_contacts,
      icon: Users,
      color: 'from-emerald-700 to-green-600',
      testId: 'stat-contacts',
    },
    {
      title: 'Total de Alunos',
      value: stats.total_students,
      icon: GraduationCap,
      color: 'from-blue-500 to-blue-600',
      testId: 'stat-students',
    },
    {
      title: 'Campanhas',
      value: stats.total_campaigns,
      icon: Send,
      color: 'from-green-500 to-green-600',
      testId: 'stat-campaigns',
    },
    {
      title: 'Mensagens Enviadas',
      value: stats.messages_sent,
      icon: CheckCircle,
      color: 'from-emerald-700 to-emerald-600',
      testId: 'stat-sent',
    },
    {
      title: 'Mensagens Pendentes',
      value: stats.messages_pending,
      icon: Clock,
      color: 'from-yellow-500 to-yellow-600',
      testId: 'stat-pending',
    },
    {
      title: 'Mensagens Falhas',
      value: stats.messages_failed,
      icon: AlertCircle,
      color: 'from-red-500 to-red-600',
      testId: 'stat-failed',
    },
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500"></div>
      </div>
    );
  }

  return (
    <div data-testid="dashboard-page">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Dashboard</h1>
        <p className="text-gray-600">Visão geral das suas campanhas e contatos</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {statCards.map((card) => {
          const Icon = card.icon;
          return (
            <Card key={card.testId} data-testid={card.testId} className="border-0 shadow-lg">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  {card.title}
                </CardTitle>
                <div className={`p-3 rounded-lg bg-gradient-to-br ${card.color}`}>
                  <Icon className="w-5 h-5 text-white" />
                </div>
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-gray-900">{card.value}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="border-0 shadow-lg">
          <CardHeader>
            <CardTitle>Últimas Atividades</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-500 text-sm">Nenhuma atividade recente</p>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-lg">
          <CardHeader>
            <CardTitle>Campanhas em Andamento</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-500 text-sm">Nenhuma campanha em andamento</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
